module.exports = __webpack_public_path__ + "static/media/frown-open.476ebdbe.svg";